export default [
    {
        title: "mainmenu.team-chat",
        route: "team-chat",
        icon: "user-group",
        resource: "teamChats",
        action: "read",
    },
];
